// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3d8qW","content":"ManualTimeModal_content__eE54o"};